export class ApiClientError extends Error {
  public status?: number;
  constructor(message: string, status?: number) {
    super(message);
    this.name = "ApiClientError";
    this.status = status;
  }
}

export interface FetchRetryOptions extends RequestInit {
  retries?: number;
  retryDelay?: number; // milliseconds for first attempt
  retryOn?: (error: unknown, attempt: number) => boolean;
}

export async function fetchWithRetry(
  url: string,
  options: FetchRetryOptions = {},
): Promise<Response> {
  const {
    retries = 3,
    retryDelay = 1000,
    retryOn = () => true,
    ...fetchOptions
  } = options;

  let attempt = 0;
  const sleep = (ms: number) => new Promise((res) => setTimeout(res, ms));

  while (true) {
    try {
      const response = await fetch(url, fetchOptions);
      if (!response.ok) {
        const errorText = await response.text();
        throw new ApiClientError(
          `HTTP ${response.status}: ${errorText}`,
          response.status,
        );
      }
      return response;
    } catch (error) {
      attempt += 1;
      if (attempt > retries || !retryOn(error, attempt)) {
        throw error;
      }
      // exponential backoff
      const delay = retryDelay * Math.pow(2, attempt - 1);
      await sleep(delay);
    }
  }
}
